import { useState } from "react";

const SearchBar = ({ onSearch }) => {
    const [input, setInput] = useState("");

    const handleSearchBtnClick = () => {
        onSearch(input);
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            onSearch(e.target.value);
        }
    }

    return (
        <div className="search">
            <input
                className="input"
                placeholder={`${Liferay.Language.get("dwtc.search.placeholder")}`}
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={handleKeyDown}
            />
            <img
                className="icon-search"
                src="/o/dwtc-theme-css/assets/svg/magnifier.svg"
                onClick={handleSearchBtnClick}
            />
        </div>
    );
};

export default SearchBar;